import { Typography } from '@material-ui/core';
import styled from 'styled-components';

export const Title = styled(Typography)`
  text-align: ${({ center }) => center && 'center'};
  font-size: 1.6em;
  font-weight: 600;
`;
